import { render, staticRenderFns } from "./AdvancedOptions.vue?vue&type=template&id=535f5948&scoped=true"
import script from "./AdvancedOptions.vue?vue&type=script&lang=js"
export * from "./AdvancedOptions.vue?vue&type=script&lang=js"
import style0 from "./AdvancedOptions.vue?vue&type=style&index=0&id=535f5948&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535f5948",
  null
  
)

export default component.exports